import MobileNavLink from "@/components/nav/mobile-link";
import MobileMenuDropdown from "@/components/mobile-menu-dropdown";
import MobileMenuShell from "@/components/header/mobile-menu-shell";

type WebsiteMobileMenuProps = Readonly<{
  isLoggedIn: boolean;
}>;

export default function WebsiteMobileMenu({
  isLoggedIn,
}: WebsiteMobileMenuProps) {
  return (
    <MobileMenuShell>
      {(close) => (
        <>
          <MobileNavLink href="/website/facilities" onClick={close}>
            امکانات
          </MobileNavLink>

          <MobileNavLink href="/website/about-us" onClick={close}>
            داستان مشاور
          </MobileNavLink>

          {/* temp */}
          {/* <MobileMenuDropdown
            label="آموزش ها"
            onItemClick={close}
            items={[
              {
                label: "آموزش‌های ویدئویی",
                href: "/video-tutorials",
              },
              {
                label: "مقالات",
                href: "/articles",
              },
            ]}
          /> */}

          <MobileMenuDropdown
            label="آگهی‌ها و مشاوران"
            onItemClick={close}
            items={[
              {
                label: "آگهی‌ها",
                href: "/advertisements-consultants/advertisements-filter",
              },
              {
                label: "بنگاه‌ها",
                href: "/advertisements-consultants/agencies",
              },
            ]}
          />

          <MobileNavLink href="/website/contact-us" onClick={close}>
            ارتباط با ما
          </MobileNavLink>

          {!isLoggedIn && (
            <MobileNavLink href="/login-otp" onClick={close} itemColor="text-brand-700">
              وارد شوید
            </MobileNavLink>
          )}
        </>
      )}
    </MobileMenuShell>
  );
}
